import { render, staticRenderFns } from "./trainDialog.vue?vue&type=template&id=1538d5ab&scoped=true&"
import script from "./trainDialog.vue?vue&type=script&lang=js&"
export * from "./trainDialog.vue?vue&type=script&lang=js&"
import style0 from "./trainDialog.vue?vue&type=style&index=0&id=1538d5ab&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1538d5ab",
  null
  
)

export default component.exports